/*
 * @Date: 2021-11-08 20:21:31
 * @LastEditors: lilin04
 * @LastEditTime: 2021-11-15 20:39:50
 */
import MegUI from 'meg-ui';
import VueSvgIcons from '@megvii-icons/vue-svg-icons';
import CubePageFilterBox from './filter-box';
import CubeFormDetail from './form-detail';
import CubeLongText from './long-text';
import CubePageHeader from './header';
import CubePageContent from './content';
import CubeNotFound from './not-found';
import CubePanel from './panel';
import CubeLicensePlate from './license-plate';
import CubePeopleTreeSelect from './people-tree-select';
import CubeSlider from './slider';
import CubeVerticalTable from './vertical-table';
import CubeWaterMark from './water-mark';
import CubeGaiaHeader from './gaia-header';
import CubeGaiaCard from './gaia-card';
import CubeGaiaCardContent from './gaia-card-content';
import CubeGaiaOverview from './gaia-overview';
import CubeGaiaDocument from './gaia-document';
import { themeColor, defaultColor, extendsInstall } from './common';
var components = [CubePageFilterBox, CubeFormDetail, CubeLongText, CubePageHeader, CubePageContent, CubeNotFound, CubePanel, CubeLicensePlate, CubePeopleTreeSelect, extendsInstall(CubeSlider), extendsInstall(CubeGaiaHeader), extendsInstall(CubeGaiaCard), extendsInstall(CubeGaiaCardContent), extendsInstall(CubeGaiaOverview), extendsInstall(CubeGaiaDocument), CubeVerticalTable, extendsInstall(CubeWaterMark)];

var install = function install(Vue) {
  Vue.use(MegUI);
  Vue.use(VueSvgIcons, {
    tagName: 'meg-icon'
  }); // eslint-disable-next-line array-callback-return

  components.map(function (component) {
    Vue.use(component);
  });
  Vue.prototype.$themeColor = themeColor;
  Vue.prototype.$defaultColor = defaultColor;
};

export { CubePageFilterBox, CubeFormDetail, CubeLongText, CubePageHeader, CubePageContent, CubeNotFound, CubePanel, CubeLicensePlate, CubePeopleTreeSelect, CubeGaiaHeader, CubeGaiaCard, CubeGaiaCardContent, CubeGaiaOverview, CubeGaiaDocument, CubeVerticalTable, CubeWaterMark };
export default install;